var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m11.146 5.546-.692-.692a.5.5 0 0 0-.708 0L8 6.6 6.254 4.854a.5.5 0 0 0-.708 0l-.692.692a.5.5 0 0 0 0 .708L6.6 8 4.854 9.746a.5.5 0 0 0 0 .708l.692.692a.5.5 0 0 0 .708 0L8 9.4l1.746 1.746a.5.5 0 0 0 .708 0l.692-.692a.5.5 0 0 0 0-.708L9.4 8l1.746-1.746a.5.5 0 0 0 0-.708Z"
})));
export default SvgHaidiCloseIcon;